import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=059872f7&"
import script from "./Forum.vue?vue&type=script&lang=ts&"
export * from "./Forum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports